import { ApolloError } from '@apollo/client';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { DisableMailForwardingMutationFn } from 'generated/graphql';

interface DisableMailForwardArgInterface {
  disableMailForwardHook: DisableMailForwardingMutationFn;
}

interface DisableMailForwardResponseInterface {
  success?: boolean;
  error?: ApolloError;
}

export const disableMailForwardThunk = createAsyncThunk(
  'disableMailForwardThunk',
  async (arg: DisableMailForwardArgInterface): Promise<DisableMailForwardResponseInterface> => {
    try {
      const result = await arg.disableMailForwardHook();

      return {
        success: result.data?.disableMailForwarding.success || false,
      };
    } catch (e) {
      return {
        error: e as ApolloError,
      };
    }
  }
);
